import * as t from "io-ts";

/** Optional equipment contents, independent of work type or material category. */
export const LocationMetaContentsCodec = t.intersection([
  t.type({state: t.keyof({EMPTY: null, PRESENT: null, UNKNOWN: null}), estimated: t.boolean}),
  t.partial({
    quantity: t.number,
    quantityUom: t.string,
    capacity: t.number,
    capacityUom: t.string,
    materialType: t.string,
    category: t.string,
    sourceDttm: t.number,
    calculatedDttm: t.number,
  }),
]);

export type LocationMetaContents = t.TypeOf<typeof LocationMetaContentsCodec>;
